import React from "react";
import { Icon } from "@chakra-ui/react";

import { VscSettings } from "react-icons/vsc";

const SettingsIcon = () => {
  return <Icon w="22px" h="38px" transform="rotate(90deg)" as={VscSettings} />;
};

export default SettingsIcon;
